export const JACK_POT_AMOUNT_KEY:{[key:string]:string} = {
  1: 'clubAmount',
  2: 'diamondAmount',
  3: 'heartAmount',
  4: 'spadeAmount',
};

export const MAX_USER_INACTIVE_STATE_DURATION:number = 900000;

